import React, { useState, useRef, useContext } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useHistory } from 'react-router-dom';
import { AppStoreContext } from '../../context/appStoreContext';
import { Button, Tooltip } from 'antd';
import { StorageNotification, UserAlertSection } from './AlertNotificationStyles';
import { withTranslation } from 'react-i18next';
import { ALERT_NOTIFICATION as trans } from './translationValues';
const NAMESPACES = ['ALERT_NOTIFICATION'];

const DraggableAlert = props => {
  const { t } = props;
  const [topValue, setTopValue] = useState(24);
  const [showNotification, setShowNotification] = useState(false);

  const { userDetails, upgradeUserPlan } = useContext(AppStoreContext);
  const { isTransactionFull, isEmailTransactionFull, isStorageFull } = userDetails;

  const dynamicDivRef = useRef(null);
  const history = useHistory();

  const [, drop] = useDrop({
    accept: 'myDiv',
    drop: (item, monitor) => {
      const dropLocation = monitor.getClientOffset();
      const startY = monitor.getInitialClientOffset().y;
      const newTopValue = topValue + dropLocation.y - startY;
      if (!isNaN(newTopValue)) {
        const minTopValue = 24;
        const maxTopValue = window.innerHeight - 94;
        const clampedTopValue = Math.min(Math.max(newTopValue, minTopValue), maxTopValue);
        setTopValue(clampedTopValue);
      }
    },
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: 'myDiv' },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drop(document.body);

  return (
    <>
      <UserAlertSection positionY={topValue} ref={drag}>
        <span class="bell fa fa-bell" onClick={() => setShowNotification(true)}></span>
      </UserAlertSection>

      <StorageNotification
        ref={dynamicDivRef}
        showNotification={showNotification}
        style={{
          top:
            70 + 24 + dynamicDivRef.current?.clientHeight + topValue > window.innerHeight
              ? topValue - (24 + dynamicDivRef.current?.clientHeight)
              : topValue + 82 + 'px',
        }}
      >
        <button className="close-icon" onClick={() => setShowNotification(false)}>
          &times;
        </button>
        {isTransactionFull && (
          <p>{t(trans.TRANSACTION_FULL_MESSAGE.key, trans.TRANSACTION_FULL_MESSAGE.value)}</p>
        )}
        {isTransactionFull && (isEmailTransactionFull || isStorageFull) && <hr />}

        {isEmailTransactionFull && (
          <p>{t(trans.EMAIL_TRANSACTION_FULL_ALERT_MESSAGE.key, trans.EMAIL_TRANSACTION_FULL_ALERT_MESSAGE.value)}</p>
        )}
        {isEmailTransactionFull && isStorageFull && <hr />}

        {isStorageFull && (
          <p>{t(trans.STORAGE_FULL_MESSAGE.key, trans.STORAGE_FULL_MESSAGE.value)}</p>
        )}

        <div className="err_desc">
          {userDetails.roles?.includes('ADMIN') ? (
            <Button onClick={() => upgradeUserPlan()}>
              {t(trans.UPGRADE_PLAN_BUTTON.key, trans.UPGRADE_PLAN_BUTTON.value)}
            </Button>
          ) : (
            <Tooltip title={t(trans.CONTACT_ADMIN_MESSAGE.key, trans.CONTACT_ADMIN_MESSAGE.value)}>
              <Button disabled={!userDetails.roles?.includes('ADMIN')} className="disable-btn">
                {t(trans.UPGRADE_PLAN_BUTTON.key, trans.UPGRADE_PLAN_BUTTON.value)}
              </Button>
            </Tooltip>
          )}
          {isStorageFull && (
            <div>
              <p> {t(trans.OR_TEXT.key, trans.OR_TEXT.value)} </p>
              <a onClick={() => history.push('/generatedDocuments')}>
                {t(trans.FREE_UP_STORAGE_LINK.key, trans.FREE_UP_STORAGE_LINK.value)}
              </a>
            </div>
          )}
        </div>
      </StorageNotification>
    </>
  );
};

export default withTranslation(NAMESPACES)(DraggableAlert);
